import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { $localize } from '@angular/localize/init'; // This import is necessary for the localize macro to work
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
